<template>
  <div >

    <div class="formPosition">
      <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
        <v-data-table    :headers="headers"  :items="estudantes" :search="searchInDb"  sort-by="data_"   class="elevation-3">

            <template v-slot:top>
                <v-toolbar flat color="white">

                    <v-divider class="mx-8" inset vertical></v-divider>

                        <v-toolbar-title>
                            Solicitar Transferência
                        </v-toolbar-title>

                    <v-divider class="mx-8" inset vertical></v-divider>

                    <!--PESQUISA--->
                        <div  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                        <div class="flex-grow-1"></div>
                        <v-btn  v-if="searchInDb"  @click="initialize(searchInDb)" text icon color="green">
                            <v-icon>cached</v-icon>
                          </v-btn>
                        <v-text-field
                          v-model="searchInDb"
                          append-icon="search"
                          label="Pesquisa"

                          single-line
                          hide-details
                        ></v-text-field>
                    <!--FIM DA PESQUISA -->

                </v-toolbar>

            <!--======================TEMPLATE DO MODAL ============================================================= -->

                             <v-dialog v-model="dialog" max-width="800px">
                                <v-card>
                                  <template >
                                      <v-toolbar color="grey lighten-2">

                                          <v-row>
                                              <v-col  cols="4" md="4">
                                                <v-btn text    @click="close()"><v-icon large color="primary" >clear</v-icon></v-btn>
                                               </v-col>
                                               <v-col cols="7" md="7"></v-col>
                                                <v-col  cols="1" md="1">
                                                    <v-btn   :disabled="!valid"  color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
                                              </v-col>
                                          </v-row>
                                      </v-toolbar>
                                  </template>

                                  <!-- ================FORMULARIO =============================-->

                                            <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
              <v-card-text>

                <v-container  >

                      <div  v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                    <v-row>
                      <v-col  cols="12" md="6">
                        <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nome"
                        :disabled="true"
                        label="Nome"
                        ></v-text-field>
                      </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field

                      required
                        :rules="[v => !!v || 'Campo obrigatorio!']"
                        v-model="editedItem.idMatricula"
                        :disabled="true"
                        label="Matricula"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">

                    </v-col>

                  </v-row>

                   <v-row>
                    <v-col cols="12" md="6">
                      <v-combobox

                       v-model="editedItem.curso"
                       :rules="ruleRequired"
                       item-value="idCurso"
                       item-text="descricao"
                       :items="cursos"
                       :disabled="true"
                       chips
                       label="Curso"
                      ></v-combobox>

                    </v-col>

                    <v-col cols="12" md="6">
                      <v-combobox

                       v-model="editedItem.instituicaoAll"
                       :rules="ruleRequired"
                       item-value="descricao"
                       item-text="descricao"
                       :items="instituicao"
                       chips
                       label="Selecione a instituiçaõ de destino"
                      ></v-combobox>
                    </v-col>

                      </v-row>

                </v-container>
              </v-card-text>

</v-form>

                                  <!-- ==================FIM DO FORMULARIO ===================== -->

                                </v-card>

                             </v-dialog>

            <!-- ======================= FIM DO TEMPLATE MODAL ====================================================== -->

            </template>

          <template v-slot:item.action="{ item }">

        <v-icon  @click="editItem(item)" >send</v-icon>

      </template>
      <template v-slot:no-data>
           Sem dados
      </template>

        </v-data-table>
    </div>

  </div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')

// const message = require('../config/messages')
export default {
  data: () => ({
    datebi: null,
    date: null,
    valid: true,
    menu: false,
    menubi: false,
    startDate: null,
    cursos: [],
    instituicao: [],
    cursosAll: [],
    isLoading: true,
    turmasAll: [],
    searchInDb: '',
    dialog: false,
    estudantes: [],
    idd: false, // simula autoinclemet

    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,

    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },
      { text: 'Matricula', value: 'idMatricula' },
      { text: 'Turma', value: 'turma' },
      { text: 'Modificado', value: 'data_' },
      { text: 'Instituição', value: 'instituicaodescricao' },
      { text: 'Solicitar', value: 'action', sortable: false }
    ],

    msg: '',

    estudantes: [],
    turmasFiltered: [],
    editedIndex: -1,
    editedItem: {

      pkPessoa: 0,
      idPessoa: '',
      idPerfil: null,
      nome: '',
      autor: '',
      data_: '',
      status_2: '',
      curso: null,
      instituicaoAll: null,
      turma: null,
      idClasse: null

    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      idPerfil: null,
      nome: '',
      autor: '',
      data_: '',
      status_2: '',
      curso: null,
      instituicaoAll: null,
      turma: null,
      idClasse: null
    }
  }),

  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }

  },

  loggedUserName () {
    return ls.get('idPessoa')
  },
  created () {
    this.initialize()
    this.initializeInstituicao()
    this.initializeCursos()
  },

  methods: {

    async initialize (searchInDb) {
      try {
        this.isLoading = true

        if (!searchInDb) {
          var payload = '{"anoacademico":"' + null + '","find":"all"}'
        } else {
          var payload = '{"anoacademico":"' + null + '","find":"' + searchInDb + '"}'
        }

        this.estudantes = await axios
          .get('/estudanteFindAll/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeInstituicao () {
      try {
        this.instituicao = await axios
          .get('/listarInstituicao')
          .then(res => res.data)
        this.instituicao = this.instituicao.filter(t => t.descricao !== ls.get('instituicaodescricao'))
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    editItem (item) {
      this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.cursosAll = this.cursos.filter(c => c.descricao === this.editedItem.curso)
      this.dialog = true
    },

    close () {
      this.dialog = false
    },

    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async save () {
      if (this.$refs.form.validate()) {
        const ls = require('local-storage')
        var params = {
          idcontrolotransferencia: null,
          fkPessoa: this.editedItem.pkPessoa,
          nomeEstudante: this.editedItem.nome,
          autor: ls.get('idPessoa'),
          idMatricula: this.editedItem.idMatricula,
          instituicaoProveniencia: this.editedItem.instituicaoAll.idInstituicao,
          idCurso: (this.cursosAll.length) ? this.cursosAll[0].idCurso : null,
          idanoacademico: this.editedItem.idClasse

        }

        try {
          let mensagem = await axios
            .post('/SolicitarTransferencia', params)
            .then(res => res.data)
          this.$store.dispatch('textMessage', {
            msg: mensagem,
            classMessage: 'msgSucess',
            timeout: 5000
          })

          if (this.editedIndex > -1) {
            Object.assign(this.estudantes[this.editedIndex], this.editedItem)
          } else {
            this.estudantes.push(this.editItem)
          }

          try {
            if (msg.affectedRows >= 1) {
              this.text = msg.affectedRows + ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', {
                msg: this.text,
                classMessage: 'msgSucess',
                timeout: 2000
              })
            }
          } catch (error) {

          }
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgError',
              timeout: 8000
            })
          } catch (error) {}
        } catch (error) {
          console.log('eroooo: ' + error)
          this.isLoading = false

          this.text = error.message
          this.$store.dispatch('textMessage', {
            msg: this.text + ' - ' + error,
            classMessage: 'msgError',
            timeout: 8000
          })
        } finally {
          this.close()
        }
      }
    }

  }
}
</script>
